import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss']
})
export class OrganizationComponent implements OnInit {

  
  showChat:boolean = false;
  showChatWindow = false;
  openSettingSidebar: boolean = false

  constructor() { }

  ngOnInit(): void {
  }

}
